import { ItemCard } from "@/components/search/item-card";
import type { ListingItem } from "@/hooks/use-paginated-feed";

/**
 * FeedItemCard — the single source of truth for mapping a feed `ListingItem`
 * onto the grid `ItemCard`. Extracted so rails (Trending, etc.) render the
 * exact same card as the main grid without duplicating the prop mapping.
 */
export function FeedItemCard({
  listing,
  currentUserId,
  onOpen,
}: {
  listing: ListingItem;
  currentUserId?: string;
  onOpen?: (id: string) => void;
}) {
  return (
    <ItemCard
      listingId={listing.id}
      title={listing.title}
      price={listing.price}
      currency={listing.currency ?? null}
      image_urls={listing.image_urls}
      stock={listing.quantity}
      scheduledPublishAt={listing.scheduled_publish_at as string}
      listingFormat={listing.listing_format ?? null}
      listingType={listing.type ?? null}
      auctionEndAt={listing.auction_end_at ?? null}
      auctionStatus={listing.auction_status ?? null}
      auctionBidCount={listing.auction_bid_count ?? null}
      offersPendingCount={listing.offers_pending_count ?? null}
      initialSaved={listing.initialSaved}
      currentUserId={currentUserId}
      sellerId={listing.user_id}
      sellerName={listing.sellerUsername}
      sellerAvatarUrl={listing.sellerAvatarUrl ?? null}
      condition={listing.condition}
      cardDetails={listing.card_details ?? null}
      description={listing.description}
      onClick={onOpen ? () => onOpen(listing.id) : undefined}
    />
  );
}
